$(document).ready(function () {
  let selector = $(".BT5 .header-custom-menu li .header-menu-a");

  // mobile menu
  $(".BT5 .header-custom-menu--mobile .svg-icon-open").hide();
  $(".BT5 .header-custom-menu--mobile .header-submenu").hide();


  $(".icon-header").click(function () {
      const isActive = $(this).hasClass("active");
  
      console.log(isActive ? "active" : "not active");
  
      // Toggle active class on current elements
      $(this).toggleClass("active");
      $(this).children(".header-menu-a--title").toggleClass("active");
      $(this).closest("li").toggleClass("active");
  
      // Rotate icon based on active state
      $(this).find(".svg-icon-close svg").css("transform", isActive ? "rotate(0deg)" : "rotate(-180deg)");
  
      // Toggle submenu display
      $(this).siblings(".header-submenu").slideToggle();
  });

  // on load
  $(".header-products-menu-li .header-products-menu-a")
    .siblings(".svg-icon-open")
    .show();
  $(".header-products-menu-li .header-products-menu-a")
    .siblings(".svg-icon-close")
    .hide();
  $(".header-products-menu-li .header-products-menu-a").addClass("active");

  $(".header-products-menu-li .header-products-menu-a")
    .parent(".icon-header")
    .siblings(".header-submenu")
    .slideDown();


  $(".footer-block .toggle-block").click(function () {
    $(this).siblings(".block-to-open").slideToggle();
    $(this).toggleClass("active");
  });


  // on hover toggle results menu
  // first block
  let blocks = $(
    ".BT5 .header-custom-menu li.header-results-menu-li .header-results-submenu .results_blocks"
  );
  let firstBlock = $(
    ".BT5 .header-custom-menu li.header-results-menu-li .header-results-submenu .results_blocks.first_block"
  );
  let secondBlock = $(
    ".BT5 .header-custom-menu li.header-results-menu-li .header-results-submenu .results_blocks.second_block"
  );

  let thirdBlock = $(
    ".BT5 .header-custom-menu li.header-results-menu-li .header-results-submenu .results_blocks.third_block"
  );
  let forthBlock = $(
    ".BT5 .header-custom-menu li.header-results-menu-li .header-results-submenu .results_blocks.forth_block"
  );

  $(
    ".BT5 .header-custom-menu li.header-results-menu-li .header-results-submenu .header-results-submenu-li"
  ).hover(function () {
    $(blocks).hide();
    $(".header-results-submenu-li-head-a").removeClass("active");
  });

  let firstLink = $(
    ".BT5 .header-custom-menu li.header-results-menu-li .header-results-submenu .header-results-submenu-li#block-1 a"
  ).attr("href");
  $(
    ".BT5 .header-custom-menu li.header-results-menu-li .header-results-submenu .results_blocks.first_block .faq-block-a"
  ).attr("href", firstLink);
  let secondLink = $(
    ".BT5 .header-custom-menu li.header-results-menu-li .header-results-submenu .header-results-submenu-li#block-2 a"
  ).attr("href");
  $(
    ".BT5 .header-custom-menu li.header-results-menu-li .header-results-submenu .results_blocks.second_block .faq-block-a"
  ).attr("href", secondLink);
  let thirdLink = $(
    ".BT5 .header-custom-menu li.header-results-menu-li .header-results-submenu .header-results-submenu-li#block-3 a"
  ).attr("href");
  $(
    ".BT5 .header-custom-menu li.header-results-menu-li .header-results-submenu .results_blocks.third_block .faq-block-a"
  ).attr("href", thirdLink);
  let forthLink = $(
    ".BT5 .header-custom-menu li.header-results-menu-li .header-results-submenu .header-results-submenu-li#block-4 a"
  ).attr("href");
  $(
    ".BT5 .header-custom-menu li.header-results-menu-li .header-results-submenu .results_blocks.forth_block .faq-block-a"
  ).attr("href", forthLink);

  $(
    ".BT5 .header-custom-menu li.header-results-menu-li .header-results-submenu .header-results-submenu-li#block-1"
  ).hover(function () {
    // over
    $(firstBlock).show();
    $(secondBlock).removeClass('active');
    $(this).children(".header-results-submenu-li-head-a").addClass("active");
  });

  // second block
  $(
    ".BT5 .header-custom-menu li.header-results-menu-li .header-results-submenu .header-results-submenu-li#block-2"
  ).hover(function () {
    // over
    $(secondBlock).show();
    $(secondBlock).addClass('active');
    $(this).children(".header-results-submenu-li-head-a").addClass("active");
  });

  // third block
  $(
    ".BT5 .header-custom-menu li.header-results-menu-li .header-results-submenu .header-results-submenu-li#block-3"
  ).hover(function () {
    // over
    $(thirdBlock).show();
    $(secondBlock).removeClass('active');
    $(this).children(".header-results-submenu-li-head-a").addClass("active");
  });

  // forth block
  $(
    ".BT5 .header-custom-menu li.header-results-menu-li .header-results-submenu .header-results-submenu-li#block-4"
  ).hover(function () {
    // over
    $(forthBlock).show();
    $(secondBlock).removeClass('active');
    $(this).children(".header-results-submenu-li-head-a").addClass("active");
  });

  // horizontal scroll
  var after_before = $(".after-before-block").width() + 20;

  //if ( $(window).width() <= 990 ){

  // horizontal scroll
  $(".arrow.arrow-prev").click(function () {
    $(this)
      .parent(".box-to-slide")
      .animate(
        {
          scrollLeft: "-=" + after_before + "px",
        },
        "slow"
      );
  });

  $(".arrow.arrow-next").click(function () {
    $(this)
      .parent(".box-to-slide")
      .animate(
        {
          scrollLeft: "+=" + after_before + "px",
        },
        "slow"
      );
  });


  // add z-index 2 when compare products modal opens on product page
  $(".compareModalFortheradomeProducts")
    .on("shown.bs.modal", function () {
      $(".section-header.shopify-section-group-header-group").css({
        "z-index": "2",
      });
      $(".shopify-section-group-header-group").css({ "z-index": "2" });
    })
    .on("hidden.bs.modal", function () {
      $(".section-header.shopify-section-group-header-group").css({
        "z-index": "3",
      });
      $(".shopify-section-group-header-group").css({ "z-index": "4" });
    });



  // toggle description on HIW page
  $(".TITB .titb-table .body").hide();
  $(".TITB .titb-table .header .close").hide();
  $(".TITB .titb-table .open-td").hide();
  $(".TITB .titb-table .header").click(function (e) {
    $(this).siblings(".body").slideToggle();
    $(this).children(".close").toggle();
    $(this).children(".open").toggle();
    $(this).parent("td").siblings(".open-td-head").find(".open-td").toggle();
  });

  // toggle description content on mobile
  $(".hidden-text").hide();
  $(".SHL .expand").click(function (e) {
    e.preventDefault();
    $(this).siblings(".hidden-text").slideDown();
    $(this).hide();
  });

  // footer menu toggle event - on mobile and tablet
  $(".footer-custom-styles .toggle-icons .minus").hide();
  $(".footer-custom-styles .toggle-icons .plus").click(function () {
    $(this)
      .parent(".toggle-icons")
      .parent(".toggle-block")
      .siblings(".block-to-open")
      .slideDown();
    $(this).hide();
    $(this).siblings(".minus").show();
  });
  $(".footer-custom-styles .toggle-icons .minus").click(function () {
    $(this)
      .parent(".toggle-icons")
      .parent(".toggle-block")
      .siblings(".block-to-open")
      .slideUp();
    $(this).hide();
    $(this).siblings(".plus").show();
  });

  // pagination
  $(".paginationBox .press-box").each(function () {
    let box = $(this).children(".page");
    let lastChild = box[box.length - 1];
    $(lastChild).addClass("lastpage");
  });
  $(".paginationBox .page-link.number").click(function (e) {
    e.preventDefault();
    let pageNumber = $(this).parent(".page-item").attr("page-number");
    $(this).parents(".pagination-box").siblings(".page").hide();
    $(this).parents(".pagination-box").siblings(".page").removeClass("active");
    setTimeout(() => {
      window.scrollTo(0, 0);
      $(this)
        .parents(".pagination-box")
        .siblings(".page" + pageNumber)
        .slideDown();
      $(this)
        .parents(".pagination-box")
        .siblings(".page" + pageNumber)
        .addClass("active");
      $(this).parent(".page-item").siblings(".page-item").removeClass("active");
      $(this).parent(".page-item").addClass("active");

      console.log(
        $(this)
          .parents(".pagination-box")
          .siblings(".page" + pageNumber)
          .hasClass("lastpage")
      );
      if (
        $(this)
          .parents(".pagination-box")
          .siblings(".page" + pageNumber)
          .hasClass("lastpage")
      ) {
        $(this)
          .parents(".pagination-box")
          .find(".nextPage")
          .addClass("disabled");
      } else {
        $(this)
          .parents(".pagination-box")
          .find(".nextPage")
          .removeClass("disabled");
      }

      console.log(
        $(this)
          .parents(".pagination-box")
          .siblings(".page" + pageNumber)
          .hasClass("firstpage")
      );
      if (
        $(this)
          .parents(".pagination-box")
          .siblings(".page" + pageNumber)
          .hasClass("firstpage")
      ) {
        $(this)
          .parents(".pagination-box")
          .find(".prevPage")
          .addClass("disabled");
      } else {
        $(this)
          .parents(".pagination-box")
          .find(".prevPage")
          .removeClass("disabled");
      }
    }, 500);
  });

  $(".paginationBox .nextPage").click(function (e) {
    e.preventDefault();
    let getActivePage = $(this)
      .parent(".page-item")
      .parents(".pagination-box")
      .siblings(".page.active")
      .attr("page-number");
    let NextNumber = parseInt(getActivePage) + 1;
    $(this).parents(".pagination-box").siblings(".page").hide();
    $(this).parents(".pagination-box").siblings(".page").removeClass("active");

    setTimeout(() => {
      window.scrollTo(0, 0);
      $(this)
        .parents(".pagination-box")
        .siblings(".page" + NextNumber)
        .slideDown();
      $(this)
        .parents(".pagination-box")
        .siblings(".page" + NextNumber)
        .addClass("active");

      $(this).parent(".page-item").siblings(".page-item").removeClass("active");
      $(this)
        .parent(".page-item")
        .siblings(".page-item" + NextNumber)
        .addClass("active");

      console.log(
        $(this)
          .parents(".pagination-box")
          .siblings(".page" + NextNumber)
          .hasClass("lastpage")
      );
      if (
        $(this)
          .parents(".pagination-box")
          .siblings(".page" + NextNumber)
          .hasClass("lastpage")
      ) {
        $(this)
          .parents(".pagination-box")
          .find(".nextPage")
          .addClass("disabled");
      } else {
        $(this)
          .parents(".pagination-box")
          .find(".nextPage")
          .removeClass("disabled");
      }

      if (
        $(this)
          .parents(".pagination-box")
          .siblings(".page" + NextNumber)
          .hasClass("firstpage")
      ) {
        $(this)
          .parents(".pagination-box")
          .find(".prevPage")
          .addClass("disabled");
      } else {
        $(this)
          .parents(".pagination-box")
          .find(".prevPage")
          .removeClass("disabled");
      }
    }, 500);
  });

  $(".paginationBox .prevPage").click(function (e) {
    e.preventDefault();
    let getActivePage = $(this)
      .parent(".page-item")
      .parents(".pagination-box")
      .siblings(".page.active")
      .attr("page-number");
    let NextNumber = parseInt(getActivePage) - 1;
    $(this).parents(".pagination-box").siblings(".page").hide();
    $(this).parents(".pagination-box").siblings(".page").removeClass("active");
    setTimeout(() => {
      window.scrollTo(0, 0);
      $(this)
        .parents(".pagination-box")
        .siblings(".page" + NextNumber)
        .slideDown();
      $(this)
        .parents(".pagination-box")
        .siblings(".page" + NextNumber)
        .addClass("active");

      $(this).parent(".page-item").siblings(".page-item").removeClass("active");
      $(this)
        .parent(".page-item")
        .siblings(".page-item" + NextNumber)
        .addClass("active");

      if (
        $(this)
          .parents(".pagination-box")
          .siblings(".page" + NextNumber)
          .hasClass("lastpage")
      ) {
        $(this)
          .parents(".pagination-box")
          .find(".nextPage")
          .addClass("disabled");
      } else {
        $(this)
          .parents(".pagination-box")
          .find(".nextPage")
          .removeClass("disabled");
      }

      console.log(
        $(this)
          .parents(".pagination-box")
          .siblings(".page" + NextNumber)
          .hasClass("firstpage")
      );
      if (
        $(this)
          .parents(".pagination-box")
          .siblings(".page" + NextNumber)
          .hasClass("firstpage")
      ) {
        $(this)
          .parents(".pagination-box")
          .find(".prevPage")
          .addClass("disabled");
      } else {
        $(this)
          .parents(".pagination-box")
          .find(".prevPage")
          .removeClass("disabled");
      }
    }, 500);
  });

  // open video in modal on press page
  $(".PRESS .open-video, .BSB .open-video, .HTVHC .open-video").click(function (
    e
  ) {
    e.preventDefault();
    let videoURL = $(this).attr("video-url");
    $(".embedDynamicVideo--modal").attr("src", videoURL);
  });
  $(".dynamicVideoModal").on("hidden.bs.modal", function (e) {
    $(".embedDynamicVideo--modal").attr("src", "");
  });

  $(".VTP .single-video-testimonial").each(function (index) {
    if (index > 4) {
      $(this).hide();
    }
  });
  let totalBoxesToShow = 5;
  $(".VTP .show-more-reviews").click(function (e) {
    e.preventDefault();
    totalBoxesToShow += 5;
    $(this)
      .parents(".show-more-reviews-parent")
      .siblings(".video-testimonials")
      .children(".single-video-testimonial")
      .slice(0, totalBoxesToShow)
      .show();
    let reviewLength = $(this)
      .parents(".show-more-reviews-parent")
      .siblings(".video-testimonials")
      .children(".single-video-testimonial").length;
    if (reviewLength <= totalBoxesToShow) {
      $(this).hide();
    }
  });

  $(".BSB .toggle-sidebar").click(function () {
    $(this)
      .parents(".toggle-sidebar-head")
      .siblings(".blog-listing")
      .slideToggle();
  });

  // hide poster image - HIW page hero video
  $(".BT5 .HTVHC .poster-img,.BT5 .HTVHC .play-img").click(function () {
    // $(this).hide();
    $(this)
      .parents(".poster-image-wrappere")
      .siblings(".poster-image-wrappere")
      .children(".hide-on-click")
      .hide();
    var videoIframe = document.getElementById("videoIframe");
    // videoIframe.src += "?autoplay=1";
    var videoContainer = document.getElementById("videoContainer");
    var player = new Vimeo.Player(videoContainer, {
      url: videoIframe.src,
      autoplay: true,
    });
    player.on("ready", function () {
      player.play().catch(function (error) {});
    });
    videoIframe.style.display = "none";
    $(this)
      .parents(".poster-image-wrappere")
      .siblings(".play-video")
      .get(0)
      .play();
  });

  // Quantity-selector
  let productQuantity;
  $(".product-form__quantity .quantity__input").change(function (e) {
    productQuantity = $(this).val();
    console.log("Quantity changed " + productQuantity);
    $(this)
      .parents(".product-form__quantity")
      .siblings(".addAdOnProductToCart")
      .attr("product-quantity", productQuantity);
  });

  // add ad on product to cart
  let original_product_variant_id = 0;
  let addon_product_variant_id = 0;
  let original_product_quantity = 1;
  let add_on_product_quantity = 1;
  $(".addAdOnProductToCart .product-form__buttons button").click(function (e) {
    e.preventDefault();
    original_product_variant_id = $(this)
      .parent(".product-form__buttons")
      .siblings(".product-variant-id")
      .attr("value");
    original_product_quantity = $(this)
      .parents(".addAdOnProductToCart")
      .attr("product-quantity");
    addon_product_variant_id = $(this)
      .parents(".addAdOnProductToCart")
      .siblings(".add-on-prod")
      .attr("add-on-product-id");
    console.log(addon_product_variant_id);
    if (
      addon_product_variant_id != "" &&
      addon_product_variant_id != undefined
    ) {
      console.log("Original Product + ADD-ON Product!");
      addItemToCart(
        addon_product_variant_id,
        original_product_variant_id,
        add_on_product_quantity,
        original_product_quantity
      );
    } else {
      console.log("Original Product!");
      addSingleItemToCart(
        original_product_variant_id,
        original_product_quantity
      );
    }
  });

  function addItemToCart(
    addon_product_variant_id,
    original_product_variant_id,
    add_on_product_quantity,
    original_product_quantity
  ) {
    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: {
        items: [
          {
            quantity: original_product_quantity,
            id: original_product_variant_id,
          },
          {
            quantity: add_on_product_quantity,
            id: addon_product_variant_id,
          },
        ],
      },
      dataType: "json",
      success: function (data) {
        console.log(data.id);
        if(!window.isUPEZLoaded) {
          window.location = "/cart";  
        }
      },
    });
  }

  function addSingleItemToCart(original_product_variant_id) {
    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: {
        items: [
          {
            quantity: original_product_quantity,
            id: original_product_variant_id,
          },
        ],
      },
      dataType: "json",
      success: function (data) {
        console.log(data.id);
        if(!window.isUPEZLoaded) {
          window.location = "/cart";  
        }
      },
    });
  }

// FAQs - Run only on the BA FAQs page
 /* if ($("body").hasClass("page-ba-faqs-liquid")) {

  $(".FAQS .single-faq .sign.minus").hide();
  $(".FAQS .single-faq .ans").hide();

  $(".FAQS .single-faq .qstn").click(function () {
    $(this).find(".sign.plus").toggle();
    $(this).find(".sign.minus").toggle();
    $(this).siblings(".ans").slideToggle();
  });

} */


if ($("body").hasClass("page-ba-faqs-liquid")) {

  $(".FAQS .single-faq .sign.minus").hide();
  $(".FAQS .single-faq .ans").hide();

  $(".FAQS .single-faq .qstn, .FAQS .single-faq .ans").click(function (e) {

    // Prevent clicks on links inside the answer from toggling the accordion
    if ($(e.target).closest("a").length) {
      return;
    }

    let $faq = $(this).closest(".single-faq");
    let $question = $faq.find(".qstn");
    let $answer = $faq.find(".ans");

    if ($answer.is(":visible")) {
      $answer.slideUp(400);
      $question.find(".sign.plus").show();
      $question.find(".sign.minus").hide();
    } else {
      $faq.siblings(".single-faq").find(".ans").slideUp(400);
      $faq.siblings(".single-faq").find(".sign.plus").show();
      $faq.siblings(".single-faq").find(".sign.minus").hide();

      $answer.slideDown(400);
      $question.find(".sign.plus").hide();
      $question.find(".sign.minus").show();
    }
  });

}



  // about us page counter
  let saved_hair;
  let regrownHair;
  let treatments;
  let newNumber;
  let digits;
  let realDigits;

  setInterval(() => {
    saved_hair = parseInt($(".initial-time-start-saved-hair").val());
    var saved_hair_prev_time = parseInt(
      $(".counter-timestamp-saved-hair").val()
    );
    const currnt_time = Math.floor(Date.now() / 1000);

    var saved_hair_difft_time = parseInt(currnt_time - saved_hair_prev_time);
    saved_hair_difft_time = parseInt(saved_hair_difft_time * 120);
    newNumber = parseInt(saved_hair + saved_hair_difft_time);
    $(".initial-number-saved-hair").text(newNumber);
    digits = newNumber.toString().split("");
    realDigits = digits.map(Number);
    let index = 0;
    $(".initial-number-saved-hair")
      .siblings(".number")
      .each(function () {
        $(this)
          .children(".number-block")
          .each(function () {
            $(this).text(realDigits[index]);
            index += 1;
          });
      });
  }, 1000);

  setInterval(() => {
    regrownHair = parseInt($(".initial-time-start-regrown-hair").val());
    var regrownHair_prev_time = parseInt(
      $(".counter-timestamp-regrown-hair").val()
    );
    const currnt_time = Math.floor(Date.now() / 1000);
    var regrownHair_difft_time = parseInt(currnt_time - regrownHair_prev_time);
    regrownHair_difft_time = parseInt(regrownHair_difft_time * 60);
    newNumber = parseInt(regrownHair + regrownHair_difft_time);
    $(".initial-number-regrown-hair").text(newNumber);
    digits = newNumber.toString().split("");
    realDigits = digits.map(Number);
    let index = 0;
    $(".initial-number-regrown-hair")
      .siblings(".number")
      .each(function () {
        $(this)
          .children(".number-block")
          .each(function () {
            $(this).text(realDigits[index]);
            index += 1;
          });
      });
  }, 1000);

  setInterval(() => {
    //treatments = parseFloat($(".initial-number-treatments").text());
    treatments = parseFloat($(".initial-time-start-treatments").val());
    var treatments_prev_time = parseFloat(
      $(".counter-timestamp-treatments").val()
    );
    const currnt_time = Math.floor(Date.now() / 1000);
    var treatments_difft_time = currnt_time - treatments_prev_time;
    treatments_difft_time = parseFloat(treatments_difft_time * 2.6);
    newNumber = treatments + treatments_difft_time;
    // console.log(Math.round(newNumber));
    $(".initial-number-treatments").text(newNumber);
    digits = Math.round(newNumber).toString().split("");
    realDigits = digits.map(Number);
    // console.log(realDigits);
    let index = 0;
    $(".initial-number-treatments")
      .siblings(".number")
      .each(function () {
        $(this)
          .children(".number-block")
          .each(function () {
            $(this).text(realDigits[index]);
            index += 1;
          });
      });
  }, 1000);
});

// Add on Product
$(document).ready(function () {
  var Add_on_pro_id = $("#add-on-prod-id").val();
  $(".addon-btn").click(function () {
    if (Add_on_pro_id) {
      $.ajax({
        type: "POST",
        url: "/cart/add.js",
        data: {
          quantity: 1,
          id: Add_on_pro_id,
        },
        dataType: "json",
        success: function (data) {
          $(".hide-main-button").trigger("click");
          // window.location.href = "/cart";
        },
      });
    }
  });

  //Addon click from cart page
  $(".add-on-btn").click(function () {
    var Add_on_pro_id = $(this).data("id");
    if (Add_on_pro_id) {
      $.ajax({
        type: "POST",
        url: "/cart/add.js",
        data: {
          quantity: 1,
          id: Add_on_pro_id,
        },
        dataType: "json",
        success: function (data) {
          window.location.href = "/cart";
        },
      });
    }
  });

  // Disable button and showing massage on cart
  var theradome_pro = $("#theradome-pro").val();
  var domecare_pro = $("#domecare-pro").val();
  var theradome_evo = $("#theradome-evo").val();
  var domecare_evo = $("#domecare-evo").val();
  var dom_evo_msg = false;
  var dom_pro_msg = false;

  if (
    theradome_evo != "theradome evo lh40" &&
    domecare_evo == "evo domecare extended warranty"
  ) {
    var dom_evo_msg = true;
  }
  if (
    theradome_pro != "theradome pro lh80" &&
    domecare_pro == "pro domecare extended warranty"
  ) {
    var dom_pro_msg = true;
  }

  if (dom_evo_msg == true && dom_pro_msg == true) {
    $(".alert-msg-for-pro").html(
      '<div class="alert-msg">For EVO DomeCare Extended Warranty and PRO DomeCare Extended Warranty you need to add Theradome EVO helmet & Theradome Pro helmet or remove EVO DomeCare Extended Warranty and PRO DomeCare Extended Warranty</div>'
    );
    $(".cart__checkout-button").addClass("disable-checkout scroll-top");
    $(".cart__checkout-button").attr("onClick", "event.preventDefault();");
  } else if (dom_evo_msg == true) {
    $(".alert-msg-for-pro").html(
      '<div class="alert-msg">For EVO DomeCare Extended Warranty you need to add Theradome EVO helmet or remove EVO DomeCare Extended Warranty</div>'
    );
    $(".cart__checkout-button").addClass("disable-checkout scroll-top");
    $(".cart__checkout-button").attr("onClick", "event.preventDefault();");
  } else if (dom_pro_msg == true) {
    $(".alert-msg-for-pro").html(
      '<div class="alert-msg">For PRO DomeCare Extended Warranty you need to add Theradome PRO helmet or PRO DomeCare Extended Warranty</div>'
    );
    $(".cart__checkout-button").addClass("disable-checkout scroll-top");
    $(".cart__checkout-button").attr("onClick", "event.preventDefault();");
  }

  $(".scroll-top").click(function () {
    $("html, body").animate({ scrollTop: 0 }, "slow");
    return false;
  });

  // Active recommendation
  var currLoc = $(location).attr("href");
  const currLocArray = currLoc.split("?");
  if (currLocArray[1] == "recommendation=true") {
    $(".Pro-recommendation").addClass("active-recommendation");
  }

  //mobile less expand

  $(".custom-expand-less").click(function () {
    $(this).css("display", "none");
    $(this).siblings(".custom-expand-btn").css("display", "block");
    $(this).siblings(".short-description").css("display", "none");
    $(this).siblings(".full-description").css("display", "block");
  });
  $(".custom-expand-btn").click(function () {
    $(this).css("display", "none");
    $(this).siblings(".custom-expand-less").css("display", "block");
    $(this).siblings(".short-description").css("display", "block");
    $(this).siblings(".full-description").css("display", "none");
  });

  $(".expand-btn").click(function () {
    $(this).css("display", "none");
    $(this).siblings(".less-btn").css("display", "block");
    $(this).siblings(".short-description").hide();
    $(this).siblings(".full-description").show();
  });

  $(document).on("click", ".less-btn", function () {
    $(this).css("display", "none");
    $(this).siblings(".expand-btn").css("display", "block");
    $(this).siblings(".short-description").show();
    $(this).siblings(".full-description").hide();
  });

  let searchParams = new URLSearchParams(window.location.search);
  let param = searchParams.get("provsevo");
  if (param == "yes") {
    $("#buy-now .modal").modal("show");
  }
});

function toggleBlock(triggerElement) {
  const block = triggerElement.nextElementSibling;
  block.classList.toggle("open-footer");
}

document.onclick = function (event) {
  const triggerElements = document.querySelectorAll(".toggle-set");
  const blocks = document.querySelectorAll(".block-to-open");

  triggerElements.forEach(function (triggerElement, index) {
    const block = blocks[index];
    if (event.target !== triggerElement && event.target !== block) {
      block.classList.remove("open-footer");
    }
  });
};

document.addEventListener('DOMContentLoaded', () => {
  let isThrottled = false;

  const buttons = document.querySelectorAll('.page-item .prevPage, .page-item .nextPage');
  if (!buttons.length) return;

  buttons.forEach(button => {
    button.addEventListener('click', (e) => {
      if (isThrottled) {
        e.preventDefault();
        e.stopImmediatePropagation();
        return;
      }

      isThrottled = true;

      setTimeout(() => {
        isThrottled = false;
      }, 600);
    });
  });
});